import React, { Component } from 'react';

class Footer extends Component {
  render() {

    if (this.props.data.main && this.props.data.about) {
      var networks = this.props.data.main.social.map((network) =>
        <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      )
      var name = this.props.data.about.name
    }

    return (
      <footer>

        <div className="row">
          <div className="twelve columns">
            <ul className="social-links">
              {networks}
            </ul>

            <ul className="copyright">
              <li>&copy; Copyright 2021 {name}</li>
            </ul>

          </div>
          <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
        </div>
      </footer>
    );
  }
}

export default Footer;
